import type { ReactNode } from 'react'

export function StaffMetricCard({
  label,
  value,
  hint,
  accent,
  icon,
}: {
  label: string
  value: ReactNode
  hint?: ReactNode
  accent?: 'blue' | 'green' | 'purple' | 'orange' | 'rose'
  icon?: ReactNode
}) {
  const accentClass = accent === 'green'
    ? 'border-l-emerald-500'
    : accent === 'purple'
      ? 'border-l-violet-500'
      : accent === 'orange'
        ? 'border-l-orange-500'
        : accent === 'rose'
          ? 'border-l-rose-500'
          : 'border-l-blue-500'

  return (
    <div className={`rounded-xl border border-slate-200 bg-white p-5 shadow-sm border-l-4 ${accentClass}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</p>
          <p className="mt-1 text-3xl font-bold text-slate-900">{value}</p>
          {hint ? <p className="mt-1 text-xs text-slate-500">{hint}</p> : null}
        </div>
        {icon ? <div className="shrink-0">{icon}</div> : null}
      </div>
    </div>
  )
}
